var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXrp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 59,
  height: 66,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#xrp_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#260070",
  d: "M32.985 60.12c14.987 0 27.137-12.15 27.137-27.137S47.972 5.845 32.985 5.845 5.848 17.995 5.848 32.983c0 14.987 12.15 27.137 27.137 27.137"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#260070",
  d: "M32.985 60.12c14.987 0 27.137-12.15 27.137-27.137S47.972 5.845 32.985 5.845 5.848 17.995 5.848 32.983c0 14.987 12.15 27.137 27.137 27.137"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#002F3A",
  d: "M32.985 60.12c14.987 0 27.137-12.15 27.137-27.137S47.972 5.845 32.985 5.845 5.848 17.995 5.848 32.983c0 14.987 12.15 27.137 27.137 27.137"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A1D3",
  d: "M57.976 14.412H45.498v9.465h12.478z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A1D3",
  fillRule: "evenodd",
  d: "M7.99 23.877h20.262v34.471h9.462V23.877h.016v-9.465H7.99z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A1D3",
  d: "M32.985 7.788c13.893 0 25.196 11.304 25.196 25.197S46.878 58.18 32.985 58.18 7.788 46.878 7.788 32.985 19.092 7.788 32.985 7.788m0-7.788C14.766 0 0 14.766 0 32.985c0 18.218 14.766 32.984 32.985 32.984 18.218 0 32.984-14.766 32.984-32.984S51.201 0 32.985 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M45.016 18.89h4.92l-10.24 10.137c-3.706 3.67-9.72 3.67-13.428 0L16.024 18.889h4.924l7.78 7.7a6.06 6.06 0 0 0 8.502 0l7.784-7.7zM28.734 39.313a6.06 6.06 0 0 1 8.503 0l7.845 7.764h4.92l-10.306-10.2c-3.71-3.669-9.721-3.669-13.428 0l-10.305 10.2h4.924z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "xrp_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h66v66H0z"
})))));
export default SvgXrp;